<template>
  <div
    :class="{
      'pc-page-cart': type == 'page',
      'athena-pc-page-cart': theme == 'athena',
      'free-box':cartItem.wdr_free_product=='Free'
    }"
  >
    <div class="drawer_inner_main_item" :class="{'athena-free-box': theme == 'athena'}">
      <div class="drawer_inner_main_item_left">
        <a :href="cartItem.product.path || cartItem.product.public_url">
          <v-lazy-img
            class="drawer-item__img"
            :data-url="featureImage.url"
            :src="featureImage.thumbnail"
          />
        </a>
      </div>
      <div class="free-item" v-if="cartItem.wdr_free_product=='Free'">
        <div class="free-label venue_sales_label">Giveaway</div>
        <div class="image-box">
          <a :href="cartItem.product.path || cartItem.product.public_url">
            <v-lazy-img
              class="drawer-item__img"
              :data-url="featureImage.url"
              :src="featureImage.thumbnail"
            />
          </a>
        </div>
        <div class="text-box">
          <p
            :style="{ marginBottom: cartItem.variant ? '0' : '10px' }"
          >
            <a
              class="page_text_font text-item"
              :href="cartItem.product.path || cartItem.product.public_url"
              >{{ cartItem.product.post_title }}</a
            >
          </p>
          <p
            class="text-item"
            v-if="cartItem.variant"
          >
            <template v-for="(subitem, subindex) in cartItem.variant.attrs">
              <span
                class="secondary_title"
                v-if="subitem.value != 'Default Title'"
                :key="subindex"
                >{{ subitem.value }}</span>
            </template>
          </p>
          <div id="discount_price">
            <v-selectprice
              :price="(cartItem.line_total/cartItem.quantity).toFixed(2)"
              :disable_select="true"
              :country="show_currency_selector ? $store.state.pricetype : ''"
              :fontSize="14"
            ></v-selectprice>
            <span>x {{cartItem.quantity}} </span>
          </div>
        </div>
      </div>
      <!-- athena抽屉右布局 -->
      <div
        class="drawer_inner_main_item_right drawer_athena"
        v-if="theme == 'athena'"
      >
        <div class="sub_itme1" style="line-height: 0">
          <p
            class="drawer_inner_main_item_right_name"
            :style="{ marginBottom: cartItem.variant ? '0' : '10px' }"
          >
            <a
              class="page_text_font"
              :href="cartItem.product.path || cartItem.product.public_url"
              >{{ cartItem.product.post_title }}</a
            >
          </p>
          <div class="price_type">
            <v-selectprice
              :price="cartItem.line_subtotal - 0"
              :disable_select="true"
              :country="show_currency_selector ? $store.state.pricetype : ''"
              :fontSize="20"
            ></v-selectprice>
          </div>
          <p
            class="drawer_inner_main_item_right_variant  text-overflow-1"
            v-if="cartItem.variant"
          >
            <template v-for="(subitem, subindex) in cartItem.variant.attrs">
              <span
                class="secondary_title"
                v-if="subitem.value != 'Default Title'"
                :key="subindex"
                >{{ subitem.value }}</span>
            </template>
          </p>
          <template v-if="cartItem.properties">
            <template v-for="(subitem, subindex) in cartItem.properties">
            <p
              class="drawer_inner_main_item_right_variant"
              v-if="subitem"
              :key="subindex + subitem"
            >
              <span> {{ subindex }} : 
                <template v-if="subitem.search(/^https?:\/\//)==-1">  {{ subitem }} </template>
                <a class="preview" v-else :href="subitem" @click.prevent="downloadFile(subitem,subitem)">Preview</a> 
              </span>
            </p>
            </template>
          </template>
          <v-qtyEye
            v-if="special_attrs_num && special_attrs_num[cartItem.product_id] % 2"
            mode='athena-inline-cart'
          ></v-qtyEye>
        </div>

        <div class="sub_itme2">
          <div class="drawer_inner_main_item_right_price">
            <div>
              <v-inputnum
                v-model="cartItem.quantity"
                @change="
                  changequantity(
                    $event,
                    cartItem.key,
                    cartItem.product_id,
                    cartItem.variation_id
                  )
                "
                :min="0"
                :step="1"
                :mode="input_type"
                :disabled="disabled_num"
              ></v-inputnum>
            </div>
            <div class="remove">
              <span
                class="text-uppercase"
                style="text-transform: Capitalize"
                @click.stop="!disabled_num && changequantity(0, cartItem.key)"
                >{{ $t("cart.remove") }}</span
              >
            </div>
          </div>
        </div>
      </div>
      <div class="drawer_inner_main_item_right page_text_font" v-if="theme != 'athena' && cartItem.wdr_free_product!='Free'">
        <div class="sub_itme1">
          <p
            class="drawer_inner_main_item_right_name"
            :style="{ marginBottom: cartItem.variant ? '0' : '10px' }"
          >
            <a
              class="page_text_font"
              :href="cartItem.product.path || cartItem.product.public_url"
              >{{ cartItem.product.post_title }}</a
            >
          </p>
          <p
            class="drawer_inner_main_item_right_variant text-overflow-1"
            v-if="cartItem.variant"
          >
            <template v-for="(subitem, subindex) in cartItem.variant.attrs">
              <span
                class="secondary_title"
                v-if="subitem.value != 'Default Title'"
                :key="subindex"
                >{{ subitem.value }}</span>
            </template>
          </p>
          <template v-if="cartItem.properties">
            <template v-for="(subitem, subindex) in cartItem.properties">
            <p
              class="drawer_inner_main_item_right_variant text-overflow-1"
              v-if="subitem"
              :key="subindex + subitem"
            >
              <span> {{ subindex }} : 
                <template v-if="subitem.search(/^https?:\/\//)==-1">  {{ subitem }} </template> 
                <a class="preview" v-else :href="subitem" @click.prevent="downloadFile(subitem,subitem)">Preview</a> 
              </span>
            </p>
            </template>
          </template>
        </div>

        <div class="sub_itme2">
          <div class="drawer_inner_main_item_right_price">
            <div>
              <v-inputnum
                v-model="cartItem.quantity"
                @change="
                  changequantity(
                    $event,
                    cartItem.key,
                    cartItem.product_id,
                    cartItem.variation_id
                  )
                "
                :min="0"
                :step="1"
                :mode="input_type"
                :disabled="disabled_num"
              ></v-inputnum>
            </div>
            <div class="remove">
              <span
                class="text-uppercase"
                style="text-transform: Capitalize"
                @click.stop="!disabled_num && changequantity(0, cartItem.key)"
                >{{ $t("cart.remove") }}</span
              >
            </div>
          </div>
          <div>
            <v-selectprice
              :price="cartItem.line_subtotal - 0"
              :disable_select="true"
              :country="show_currency_selector ? $store.state.pricetype : ''"
              :fontSize="14"
            ></v-selectprice>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import vInputnum from "../../../views/venue/js/common/inputnum.vue";
import vQtyEye from "@/views/athena/js/common/qtyEye.vue";
// import LazyImgVue from '../LazyImg.vue';

export default {
  props: [
    "changequantity",
    "cartItem",
    "disabled_num",
    "type",
    "input_type",
    "show_currency_selector",
    "theme",
    "special_attrs_num",
  ],
  data() {
    return {
      // defaultImage
      featureImage:this.cartItem?.variant?.feature_image || this.cartItem?.product?.feature_image || {}
    };
  },
  components: {
    vInputnum,
    vQtyEye,
    // [LazyImgVue.name]: LazyImgVue
  },
};
</script>
<style scoped lang='scss'>
.free-box {
  background: #fafafa;
  padding: 0 !important;
  .athena-free-box {
     margin-top:-30px !important;
  }
  .drawer_inner_main_item {
     padding: 15px 0 !important;
    .drawer_inner_main_item_left,
    .drawer_inner_main_item_right {
     display: none !important;
   }
   .free-item {
     width: 280px;
     min-height: 90px;
     margin-left: 15px;
     display: flex;
     align-content: center;
     background: #fff;
     .free-label {
      position: absolute;
      width: 70px;
      height: 20px;
      color:#fff;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 3px;
      box-sizing: border-box;
      border-radius: 28px;
      font-size: 9px;
     }
     .image-box {
        width: 90px;
        display: inline-block;
        vertical-align: middle;
        margin-right: 15px;
        margin-left: 10px;
        padding: 10px 0;
        a {
          display: flex;
          align-items: center;
          width: 70px;
          height: 100%;
          img {
            width: 100%;
            height: auto;
          }
        }
     }
     .text-box{
       display: flex;
       align-items: baseline;
       flex-direction: column;
       justify-content: space-evenly;
       width: 100%;
       padding: 6px;
       .text-item {
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1;
        padding-bottom: 2px;
        line-height: 20px;
        overflow: hidden;
        text-overflow: ellipsis;
        text-overflow: -o-ellipsis-lastline;
       }
       #discount_price {
        font-size: 12px;
        color: #222222;
        &::v-deep {
          .product_price_price {
            .money {
              font-size: 12px !important;
              color: #222222 !important;
            }
          }
        }
      }
     }
  }
  }
}
.drawer_inner_main_item {
  padding-top: 10px;
  padding-bottom: 10px;
  font-family: auto;
  a{
    color: inherit;
  }
  .drawer_inner_main_item_left {
    width: 25%;
    max-width: 90px;
    display: inline-block;
    vertical-align: top;
    a {
      display: inline-block;
      width: 100%;
      height: 100%;
      img {
        width: 100%;
        height: auto;
      }
    }
  }
  .drawer_inner_main_item_right {
    display: inline-block;
    width: 73%;
    max-width: 73%;
    padding-left: 12px;
    .sub_itme2 {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 10px;
      .remove {
        span {
          cursor: pointer;
          font-size: 12px;
          padding-top: 8px;
          text-decoration: underline;
          display: inline-block;
        }
      }
    }
    .drawer_inner_main_item_right_name {
      opacity: 0.9;
      line-height: 1;
      max-width: 100%;
      a {
        display: inline-block;
        width: 100%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        line-height: 1;
        font-size: 14px;
        color: #3a3a3a;
        text-decoration: none;
      }
    }
    .drawer_inner_main_item_right_variant {
      opacity: 0.9;
      display: inline-block;
      width: 100%;
      line-height: 1;
      padding-top: 5px;
      span {
        font-size: 12px;
        color: #3a3a3a;
      }
      & > span:not(:last-child)::after {
        content: " / ";
      }
      .preview:hover {
        opacity: 0.7;
        cursor: pointer;
      }
    }
    p {
      margin-bottom: 0;
    }
    .drawer_inner_main_item_right_price {
      margin-top: 3px;
      & > div {
        line-height: 1;
      }
      div:last-child {
        text-align: left;
      }
      .el-input-number {
        width: 75px;
        line-height: 23px;
        height: 23px;
        .el-input-number__decrease,
        .el-input-number__increase {
          background-color: transparent !important;
          border-radius: 0;
          width: 23px;
          height: 22px;
          color: #3a3a3a !important;
          &:hover {
            background-color: #000 !important;
            i {
              color: white;
            }
          }
        }
        .el-input-number__decrease {
          border-right: 1px solid #000 !important;
        }
        .el-input-number__increase {
          border-left: 1px solid #000 !important;
        }
        .el-input {
          .el-input__inner {
            background-color: transparent !important;
            border-radius: 0;
            border: 1px solid #000;
            padding-left: 23px;
            padding-right: 23px;
            height: 23px;
            line-height: 23px;
            font-size: 13px;
            font-weight: 600;
          }
        }
      }
    }
  }
  &:last-child {
    border-bottom: unset;
  }
}

@media screen and (min-width: 768px) {
  .pc-page-cart {
    padding: 20px 0;
    padding-left: 15px;
    margin-left: -15px;
    border-bottom: 1px solid #ececed;
    .drawer_inner_main_item {
      display: flex;
      justify-content: unset;
      align-items: center;
      .drawer_inner_main_item_left {
        margin-right: 20px;
      }
      .drawer_inner_main_item_right {
        display: flex;
        justify-content: space-around;
        width: 100%;
        max-width: 100%;
        padding: 0;
        .sub_itme1 {
          max-width: 30%;
          width: 100%;
          .drawer_inner_main_item_right_name {
            margin-bottom: 10px !important;
            a {
              overflow: unset;
              white-space: normal;
              font-size: 16px;
              font-weight: 400;
              line-height: 22px;
            }
          }
        }

        .sub_itme2 {
          justify-content: space-around;
          align-items: normal;
          flex: 1;
          margin-top: 10px;
          & > div {
            width: 50%;
            text-align: center;
            &:first-child{
              padding-left: 28px;
              min-width: 140px;
            }
          }
          .remove {
            text-align: center;
          }
        }
      }
    }
  }
  .pc-page-cart:last-child {
    border-bottom: none;
  }
}
@media screen and (max-width: 767px) {
  .pc-page-cart {
    border-bottom: 1px solid #ececed;
    padding: 10px 0;
  }
  .pc-page-cart:last-child {
    border-bottom: none;
  }
  .drawer_inner_main_item {
    padding-top: 10px;
    padding-bottom: 10px;
    display: flex;
    // align-items: center;
    .drawer_inner_main_item_right {
      flex: 1;
    }
  }
}
</style>
